<template>
  <Dialog
    v-model:visible="showModalRef"
    :close-on-escape="store.getters.dialogsCloseOnEscape"
    :dismissableMask="store.getters.dialogsDismissableMask"
    :modal="store.getters.dialogsModal"
  >
    <template #header>
      Recuperar contraseña
      <i
        class="custom-close-dialog-button cursor-pointer p-2 pi pi-times"
        @click="closeModal()"
      ></i
    ></template>

    <div
      :class="[loadingForm ? 'flex' : 'hidden']"
      class="justify-content-center align-items-center h-full"
    >
      <i class="pi pi-spinner pi-spin" style="font-size: 2rem"></i>
    </div>

    <Form
      ref="formRef"
      v-bind="formConfigRef"
      :class="[loadingForm ? 'hidden' : 'flex']"
    />

    <template #footer>
      <div class="col-12">
        <div class="flex justify-content-between flex-wrap gap-3">
          <Button label="Cancelar" severity="secondary" @click="closeModal()" />
          <Button
            label="Enviar correo de recuperación"
            @click="save"
            :loading="loading || loadingForm"
            loading-icon="pi pi-spinner"
          />
        </div>
      </div>
    </template>
  </Dialog>
</template>

<script setup>
import { ref } from "vue";
import { useToast } from "primevue/usetoast";
import Dialog from "primevue/dialog";
import Button from "primevue/button";
import { useStore } from "vuex";
import { Form, useImmer } from "@sttedra_ui/framework";

import useFormConfig from "@/pages/_root/views/login/recover-password-dialog/recover-password-dialog-form.view-config.js"; // eslint-disable-line
import { sendRecoverEmail } from "@/api/auth/auth.api.js";

// #region Props, Emits
const emit = defineEmits(["saved"]);
// #endregion

// #region Params, Ref, Reactives, Computed
const loadingForm = ref(false);
const loading = ref(false);
const store = useStore();
const toast = useToast();
const showModalRef = ref(false);
const formRef = ref(null);
const formConfig = ref(null);
const { ref: formConfigRef } = useImmer(formConfig);
// #endregion

// #region Functions
async function showModal() {
  loadingForm.value = true;
  showModalRef.value = true;

  formConfig.value = new useFormConfig(null);
  loadingForm.value = false;
}

async function save() {
  const invalid = !(await formRef.value?.v$Ref.$validate());

  if (invalid) return;

  loading.value = true;

  const data = { ...formRef.value.state$$.values };

  let response = await sendRecoverEmail(data);

  if (response.status == 200) {
    toast.add({
      severity: "success",
      summary: `Correo enviado`,
      detail: `Se ha enviado el correo de recuperación correctamente`,
      life: 3000,
    });

    showModalRef.value = false;

    emit("saved", response.data);
  } else {
    toast.add({
      severity: "error",
      summary: "Error",
      detail: `Ha ocurrido un error al enviar el correo de recuperación`,
      life: 3000,
    });
  }

  loading.value = false;
}

function closeModal() {
  showModalRef.value = false;
}
// #endregion

// #region Effects, Hooks
// #endregion

// #region Provide, Expose
defineExpose({
  showModal,
});
// #endregion
</script>
